import React, {FunctionComponent} from 'react';
import {Spacer} from '../../styles/page';
import {Wrapper} from './DisplayMessage.styles';

export enum DisplayMessageTypes {
  ERROR,
  WARNING,
  SUCCESS,
}

export interface DisplayMessageProps {
  type?: DisplayMessageTypes;
  children: object;
  style?: React.CSSProperties;
}

export const DisplayMessage: FunctionComponent<DisplayMessageProps> = ({
  type,
  children,
  ...rest
}) => {
  const messageType = type || DisplayMessageTypes.ERROR;

  return (
    <>
      <Wrapper type={messageType} {...rest}>
        {children}
      </Wrapper>
      <Spacer />
    </>
  );
};
